import { FC, useMemo, useContext } from 'react';
import { styled } from '@mui/material/styles';
import { TenantContext } from '../../../core/TenantProvider/contexts';

import AEText from '../AEText';
import { HexColour } from '../../../core/types/ThemeConfigTypes';
import { ReactComponent as StatusWarning } from "./icons/organization-status-warning-icon.svg";

interface AEValidationErrorMessageProps {
  message: string;
}

interface ErrorMessageProps {
  marginTop?: number;
}

const ErrorMessage = styled(AEText, {
  shouldForwardProp: (prop) => prop !== 'marginTop'
})<ErrorMessageProps>(({ theme, marginTop }) => {
  const {
    colours: {
      text: { textError }
    }
  } = theme;



  const COLOUR_TEXT_TEXT_ERROR: HexColour = textError;

  return {
    marginTop: 5,
    color: COLOUR_TEXT_TEXT_ERROR
  };
});

const ErrorIconContainer = styled('div')(({ theme }) => {
  const {
    colours: {
      text: { textError }
    }
  } = theme;

  const COLOUR_TEXT_TEXT_ERROR: HexColour = textError;

  return {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'left',
    verticalAlign: 'middle',
    flexWrap: 'wrap',
    gap: '5px',
    marginTop: '5px',
    '> svg': {
      width: '18px',
      height: '18px'
    },

    '> svg > path': {
      fill: COLOUR_TEXT_TEXT_ERROR
    }
  };
});

const StatusWarningIcon = styled(StatusWarning)(({ theme }) => {
  const {
    colours: {
      text: { textError }
    }
  } = theme;

  const COLOUR_TEXT_TEXT_ERROR: HexColour = textError;

  return {
    marginRight: '6px',
    position: 'relative'
  };
});


const AEValidationErrorMessage: FC<AEValidationErrorMessageProps> = ({ message }) => {

  const { tenant } = useContext(TenantContext);

  return (<ErrorIconContainer>
    <StatusWarningIcon  data-testid="error-icon" />
    <ErrorMessage variant="subtitle2" type="normal" text={message} />
  </ErrorIconContainer>)
};

export default AEValidationErrorMessage;
